// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2lpac","header":"ReportDetails_header__2IWVv","title":"ReportDetails_title__3ZR-f","left":"ReportDetails_left__1BC4r"};